<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="getBackButtonRoute"
    ref="bank-account-transaction"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :warningSummary="warningSummary"
    :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
    :gcPopupBankTransferConfig="gcPopupBankTransferConfig"
  />
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
import TransactionTemplate from "../../templates/transaction.vue";
import { BankAccountsServices } from "../../_services/api/finance/bankAccounts";
import { BankTransferService } from "../../_services/api/finance/bank-transfer.service";
import {
  BankAccountTransferTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/finance/bank-account-transaction";
import { FeatureStorage } from "../../_services/storage";
import { BankAccountTransactionServices } from "../../_services/api/finance/bank-account-transaction.service";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { getDefaultUserSettings } from "../../_store/helpers";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      setLoading: false,
      bankTransferModalVisible: false,
      loaded: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      warningSummary: [],
      backRoute: "/bank-accounts",
      TradingPartners: undefined,
      dataModel: {
        Status: undefined,
        AccountName: undefined,
        BSBNO: undefined,
        AccountNo: undefined,
        BookBalance: undefined,
        StatementBalance: undefined,
        StatementDate: undefined,
        OutstandingPayables: undefined,
        OutstandingReceivables: undefined,
        AccountBalance: undefined,
        popUpScreenOption: undefined,
        FXBookBalance: undefined,
      },
      selectorPopup: undefined,
      gcPopUpSelectedScreen: undefined,
      gcSundryTransactionPopupVisible: false,
      BaseCurrency: undefined,
      CompanyCode: undefined,
      FXCurrency: undefined,
      ExchangeRate: undefined,
    };
  },
  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    isBankAccountCurrencyTheSameAsCompanyCurrency() {
      return this.BaseCurrency == this.FXCurrency;
    },
    getBackButtonRoute() {
      return this.backRoute;
    },
    gcPopupBankTransferConfig() {
      return {
        visible: this.bankTransferModalVisible,
        callback: this.bankTransferCallback,
      };
    },
    gcSundryTransactionPopupConfig() {
      return {
        gcPopupVisible: this.gcSundryTransactionPopupVisible,
        gcPopupCallBack: this.gcSundryTransactionPopupCallBack,
        init: this.initialized,
        onSaveCallBack: this.onSaveCallBack,
        parentScreen: "bank-account-transaction",
        dataModel: {
          AccountNo: this.dataModel.AccountNo,
          BSBNO: this.dataModel.BSBNO,
          BankAccountCode: this.baseView.id,
          FXCurrency: this.FXCurrency,
          ExchangeRate: this.ExchangeRate,
        },
        formOptions: {
          gcLabelLocation: "left",
        },
        titleLines: [
          `${this.dataModel.AccountName}`,
          `${this.dataModel.BSBNO} ${this.dataModel.AccountNo}`,
        ],
      };
    },
    getDataModel() {
      return this.dataModel;
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Bank Accounts-Transaction",
          pdf: false,
          audit: false,
          status: true,
          notes: false,
          save: false,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          ScreenName: "Bank Accounts - Transaction",
          selectedIndex: GetIndexByTabName("Transactions", this.baseView.id),
          tabs: BankAccountTransferTabs(this.baseView.id),
          title: {
            primary: {
              primary: {
                dataField: "AccountName",
                text: "",
              },
            },
            secondary: {
              dataField: "AccountNo",
              text: `${this.getBSBNO()} `,
            },
          },

          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "FXBookBalance",
                      dataField: "FXBookBalance",
                      label: {
                        text: `GCORP Balance  (${this.FXCurrency})`,
                      },
                    },

                    {
                      screenField: "FXLineTotal",
                      dataField: "LastReconciledAmount",
                      label: {
                        text: `Reconciled Balance (${this.FXCurrency})`,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "Total",
                      dataField: "OutstandingPayables",
                      label: {
                        text: `Add O/S Payments  (${this.FXCurrency})`,
                      },
                      allowUpdate: false,
                    },
                    {
                      screenField: "Date",
                      dataField: "LastReconciledDate",
                      label: {
                        text: "Reconciled Date",
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "Total",
                      dataField: "OutstandingReceivables",
                      label: {
                        text: `Less O/S Receipts  (${this.FXCurrency})`,
                      },
                      allowUpdate: false,
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "FXTotal",
                      dataField: "AccountBalance",
                      label: {
                        text: `Account Balance  (${this.FXCurrency})`,
                      },
                      allowUpdate: false,
                    },
                    {
                      screenField: "FXBalance",
                      dataField: "BookBalance",
                      label: {
                        text: `Book Balance (${this.BaseCurrency})`,
                      },
                      allowUpdate: false,
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getScreenJson() {
      return {
        title: "Bank Accounts Transaction",
        endpoint: {
          primary: undefined,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CashBook",
              filter: [["BankAccountCode", "=", parseInt(this.baseView.id)]],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.cashBookPostProcess,
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            openFilterByDefault: true,
            expand: true,
            review: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                visible: FeatureStorage.checkPermission(
                  "BankTransactions",
                  "create"
                ),
                buttonLocation: "left",
                clickAction: () => {
                  this.visibleGcSundryTransactionPopup();
                },
              },
              {
                // icon: "plus",
                elementAttr: {
                  class: "cx-color-button",
                },
                visible: FeatureStorage.checkPermission(
                  "BankTransfer",
                  "create"
                ),
                label: "Transfer",
                buttonLocation: "left",
                clickAction: () => {
                  this.showBankTransferModal();
                },
              },
            ],
          },
          columns: [
            {
              screenField: "Date",
              gridDataField: "Date",
              filterDataField: "Date",
              showInColumnChooser: true,
              filterIndex: 1,
              allowSorting: true,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "FXAmount",
              filterIndex: 0,
              type: "Integer",
              filterDataField: "FXAmountAbs",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "TradingPartner",
              cellTemplate: undefined,
              cellTemplateRecord: undefined,
              exportFields: undefined,
              label: "Partner",
              allowSorting: true,
              showInColumnChooser: true,
              filterIndex: 3,
              filterDataField: "TradingPartner",
              type: "Text",
            },

            {
              screenField: "Customer",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 4,
            },
            {
              screenField: "Supplier",
              filterDataField: "SupplierCode",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 4,
            },
            {
              screenField: "TransactionType",
              dataField: "TransactionType",
              filterDataField: "TransactionType",
              filterIndex: 4,
              label: "Type ",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              minWidth: ColumnWidth.PaymentType.minWidth,
              maxWidth: ColumnWidth.PaymentType.minWidth,
              dataSourceConfig: {
                data: [
                  "Supplier Payment",
                  "Customer Receipt",
                  "Sundry Payment",
                  "Sundry Receipt",
                ],
              },
            },
            {
              screenField: "TransactionCode",
              // type: "String",
              dataField: "ComputedTransaction",
              label: "Transaction",
              minWidth: ColumnWidth.Code.minWidth,
              maxWidth: ColumnWidth.Code.minWidth,
              showInColumnChooser: true,
              visible: true,
              allowSearch: true,
              allowSorting: true,
              hyperlink: {
                url: "",
                dataField: "ComputedTransaction",
                // dataField: "RefNo",
                gridUrlDataFields: ["TransactionType"],
                gridUrlConditions: [
                  {
                    values: [{ TransactionType: "Customer Receipt" }],
                    url: `customer-receipt/review/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Sundry Receipt" }],
                    url: `sundry-receipt/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Supplier Payment" }],
                    url: `supplier-payment/review/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Sundry Payment" }],
                    url: `sundry-payment/__ID__`,
                  },
                ],
                target: "_blank",
              },
              filterIndex: 0,
              filterDataField: "ComputedTransaction",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "Reference",
              label: "Reference",
              dataField: "Reference",
              visible: true,
              showInColumnChooser: true,
              minWidth: ColumnWidth.PaymentReference.minWidth,
              width: ColumnWidth.PaymentReference.minWidth,
            },
            {
              screenField: "ExchangeRate",
              visible: !this.isBankAccountCurrencyTheSameAsCompanyCurrency,
              minWidth: ColumnWidth.ExchangeRate.minWidth,
              maxWidth: ColumnWidth.ExchangeRate.minWidth,
              allowSearch: false,
            },
            {
              screenField: "FXBalance",
              dataField: "FXSpent",
              visible: !this.isBankAccountCurrencyTheSameAsCompanyCurrency,
              format: "Decimal-16-2",
              label: `Spent (${this.FXCurrency}) `,
              allowSorting: true,
              showInColumnChooser: true,
              allowSearch: false,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
            },
            {
              screenField: "FXBalance",
              dataField: "Spent",
              format: "Decimal-16-2",
              label: `Spent (${this.BaseCurrency})`,
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
            },
            {
              screenField: "FXAmount",
              dataField: "FXReceived",
              label: `Received (${this.FXCurrency}) `,
              allowSorting: true,
              showInColumnChooser: true,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
              visible: !this.isBankAccountCurrencyTheSameAsCompanyCurrency,
              allowSearch: false,
            },
            {
              screenField: "FXAmount",
              dataField: "Received",
              label: `Received (${this.BaseCurrency})`,
              allowSorting: true,
              showInColumnChooser: true,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterDataField: "DateCreated",
              filterIndex: 2,
              label: "Date Created",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              sortOrder: "desc",
              maxWidth: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "CreatedBy",
              dataField: "CreatedBy",
              label: "Created By",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              maxWidth: ColumnWidth.Name.width,
            },
            {
              screenField: "OrderStatus",
              dataField: "FriendlyStatus",
              label: "Status",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              filterIndex: 5,
              filterDataField: "FriendlyStatus",
              dataSourceConfig: {
                data: ["Reconciled", "Unpresented"],
              },
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Unreconcile",
                      data: data,
                      clickAction: async (e) =>
                        await this.saveCancelBankReconciliation(e),
                      disabled: data.data.Status != "C",
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
          ],

          valueChangedEventListners: [],
        },
      };
    },
  },
  async created() {
    this.initialized();
  },
  methods: {
    onSaveCallBack() {
      this.$refs["bank-account-transaction"].$refs[
        "transactionGrid"
      ].gridRepaint();
    },
    bankTransferCallback(updated) {
      this.bankTransferModalVisible = false;
      if (updated) {
        this.loaded = false;
        this.onSaveCallBack();
        this.initialized();
      }
    },
    async saveCancelBankReconciliation(e) {
      var payload = {
        CashNo: e.CashNo,
        CashBookDetail: {
          RefNo: e.RefNo,
          CashNo: e.CashNo,
          ChequeNo: "",
          DateIn: e.Date,
          TransactionType: e.TransactionType,
          Comments: e.Comment,
          Amount: e.Amount,
          BankAccount: e.BankAccountCode,
        },
      };
      this.setLoading = true;
      this.loaded = false;
      await BankAccountTransactionServices.cancelBankReconciliation(
        payload
      ).then(async () => {
        await this.initialized();
        this.onSaveCallBack();
        this.setLoading = false;
      });
    },
    visibleGcSundryTransactionPopup() {
      this.gcSundryTransactionPopupVisible = true;
    },
    getBSBNO() {
      return this.dataModel.BSBNO;
    },
    async onGcPopUpUpdate(e) {
      this.gcPopupCallBack();
      var payload = {
        SourceBankAccount: e.FromBank,
        DestinationBankAccount: e.ToBank,
        TransferAmount: e.Amount,
        FXTransferAmount: this.getFXTransferAmount(),
        ExchangeRate: e.ExchangeRate,
        Comment: e.Comments,
        TransferDate: new Date(e.Date).toSaveDate(),
      };
      this.setLoading = true;
      await BankTransferService.saveBankTransferService(payload)
        .then((res) => {
          if (res) this.setLoading = false;

          this.$notify(
            `Bank Transfer #${res.data.Code}  Successfully Updated`,
            "success"
          );
          this.loaded = false;
          this.initialized();
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Save Failed.",
            time: new Date().getTime(),
          };
        });
    },
    showBankTransferModal() {
      this.bankTransferModalVisible = true;
    },
    async initialized() {
      await BankAccountsServices.getBankRecordByCode(this.baseView.id).then(
        async ({ data }) => {
          this.dataModel.AccountName = data.value[0].AccountName;
          this.dataModel.BSBNO = data.value[0].BsbNo;
          this.dataModel.AccountNo = data.value[0].AccountNo;
          this.dataModel.BookBalance = data.value[0].BookBalance;
          this.dataModel.StatementBalance = data.value[0].FXStatementBalance;
          this.dataModel.StatementDate = data.value[0].StatementDate;
          this.dataModel.OutstandingPayables =
            data.value[0].FXOutstandingPaymentTotal;
          this.dataModel.OutstandingReceivables =
            data.value[0].FXOutstandingReceiptTotal;
          this.dataModel.AccountBalance = data.value[0].AccountBalance;
          this.dataModel.Status = data.value[0].FriendlyStatus;
          this.FXCurrency = data.value[0].CurrencyCode;
          this.ExchangeRate = data.value[0].ExchangeRate;

          this.dataModel.FXBookBalance = data.value[0].FXBookBalance;
          this.dataModel.LastReconciledAmount =
            data.value[0].LastReconciledAmount;
          this.dataModel.LastReconciledDate = data.value[0].LastReconciledDate;
        }
      );

      this.BaseCurrency = getDefaultUserSettings().CurrencyCode;
      this.CompanyCode = getDefaultUserSettings().CompanyCode;
      this.loaded = true;
    },
    cashBookPostProcess(data) {
      data.forEach((element) => {
        element.Transaction = element.ComputedTransaction;
      });

      return data;
    },
    gcSundryTransactionPopupCallBack() {
      this.gcSundryTransactionPopupVisible = false;
    },
  },
};
</script>

<style>
.non-edit-cell-textbox-field {
  font-weight: 600;
  font-size: 14px !important;
}
</style>
